<template>
	<div class="erji">
		<div class="container">
			<div class="main">
				<div class="menu-wp fl visible-lg-block">
					<hmenu :curID="this.curID" :menuID="this.menuID" ></hmenu>
				</div>
				<div class="erji-content-wp">
					<router-view></router-view>
				</div>
				<div class="clear"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'slider',
		data(){
			return{
				menuID:'',
				curID:''
			}
		},
		methods:{

		},
		created(){
			this.menuID = this.$route.params.id;
			this.curID = this.$route.query.category_id;
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					this.menuID = to.params.id;
					this.curID = to.query.category_id;
			}
		},
		mounted(){

		}
	}
</script>

<style>
</style>